import { mediaList } from '../constants';

const initialState = {
  isFetching: false,
  fetched: false,
  mediaListError: false,
  bbsList: [],
  blogList: [],
  newsList: [],
  smList: []
};

export function mediaLists(state = initialState, action) {
  switch (action.type) {
    case mediaList.REQUEST:
      return {
        ...state,
        isFetching: true,
        lastUpdated: action.receivedAt };
    case mediaList.SHOWE_ERROR:
      return {
        ...state,
        mediaListError: action.mediaListError
      };
    case mediaList.CLEAN_ERROR:
      return {
        ...state,
        mediaListError: action.mediaListError
      };
    case mediaList.RECEIVE:
      return {
        ...state,
        bbsList: action.bbsList,
        blogList: action.blogList,
        newsList: action.newsList,
        smList: action.smList,
        isFetching: false,
        fetched: true,
        lastUpdated: action.receivedAt
      };
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/mediaList.reducer.js